import styled from "styled-components";
import { Textbox } from "capitalrx-components-2.0/lib/forms";

export const ThemedTextBox = styled(Textbox)<{ $isError?: boolean; }>`
  width: 100%;

  .input {
    &:not(:disabled) {
      &:not(:read-only) {
        border-color: ${(props) => props.$isError ? "#B8222A" : "darkgray"};
        &:focus {
          border-color: darkgray !important;
          box-shadow: 0px 0px 4px ${(props) => props.theme.primary_color} !important;
        }
      }
    }
  }
`;
